module.exports = __webpack_public_path__ + "static/img/btn2-checked.e67aab40.png";